var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgX = function SvgX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m16.24 39.44 9.73-9.727m0 0L16.24 16.24h6.443l7.03 9.73 9.727-9.73M25.97 29.713l7.025 9.727h6.445l-9.73-13.472"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#E6E6E6",
    strokeWidth: 1.5,
    d: "M51.04 27.84c0 12.814-10.386 23.2-23.2 23.2s-23.2-10.386-23.2-23.2 10.387-23.2 23.2-23.2c12.814 0 23.2 10.387 23.2 23.2Z"
  })));
};
export default SvgX;